import { setupWorker } from 'msw';
import { browserHandler } from './handlers/handler';

export const worker = setupWorker(...browserHandler);
